<template>
    <div class="infocont">
        <!-- CELLDATA ALERT BOX -->
        <div
            v-if="showCellDataMessage"
            class="alert alert-warning"
            style="border: 1px solid #eaaa00; background: #fff9db; padding: 8px; border-radius: 4px; margin-bottom: 1rem;"
        >
            <strong>Important:</strong> If you select the data provisioning option for the {{ product.CONFIG_PREFIX }}, you must also add the <a href="/order/celldata" title="The CELLDATA accessory is required when selecting the data provisioning option" target="_blank">CELLDATA accessory</a> to your cart.
        </div>

        <table class="prod">
            <tr v-if="orderMeta.canSeePrices && !product.RETIRED">
                <td>&nbsp;</td>
                <td class="price">
                    <a v-if="!product.RETIRED && orderMeta.p2 != ''"
                        class="hidden-xs prefs">
                        {{orderMeta.p2Heading}}
                    </a>
                </td>
                <td class="price">
                    <a v-if="!product.RETIRED && orderMeta.p1 != ''"
                        class="hidden-xs prefs">
                        {{orderMeta.p1Heading}}
                    </a>
                </td>
            </tr>
            <tr class="prow" :class="{liner: product.PROD_CONFIG}">
                <td>
                    <a :href="product.PROD_URL"
                        class="prod-config text-primary">
                        <span
                            v-if="product.configuration.config">{{configName}}</span>
                        <span v-else
                            class="pconfig">{{product.CONFIG_PREFIX || product.PROD_MODEL}}
                            <span
                                v-if="!product.PROD_CONFIG">{{product.PROD_DESC}}</span>
                            <span
                                v-if="orderMeta.level <= 3 && !product.PROD_CONFIG"
                                class="hidden-xs">
                                <span class="part"> -
                                    {{product.PROD_ITEMNO}}</span>
                            </span>
                        </span>
                    </a>
                    <span
                        v-if="isGSA"
                        class="label label-primary white marginleft10"
                        :title="labels[2444]">
                        {{labels[2444]}}
                    </span>
                </td>
                <td class="price">
                    <div v-if="orderMeta.canSeePrices && !product.RETIRED && orderMeta.p2 != ''"
                        v-html="price2"></div>
                </td>
                <td class="price text-primary">
                    <div v-if="orderMeta.canSeePrices && !product.RETIRED && orderMeta.p1 != ''"
                        v-html="price1"></div>
                </td>
            </tr>
            <tr v-if="product.PROD_CONFIG">
                <td>
                    <div class="prod-title">
                        {{product.CONFIG_PREFIX || product.PROD_MODEL }} {{product.PROD_DESC}}
                        <span v-if="orderMeta.level <= 3"
                            class="hidden-xs">
                            <span class="part"> -
                                {{product.PROD_ITEMNO}}</span>
                        </span>
                    </div>
                </td>
                <td class="price">
                    <div v-if="orderMeta.canSeePrices && !product.RETIRED && orderMeta.p2 != ''"
                        v-html="product.PRICE2"></div>
                </td>
                <td class="price text-primary">
                    <div v-if="orderMeta.canSeePrices && !product.RETIRED && orderMeta.p1 != ''"
                        v-html="product.PRICE1"></div>
                </td>
            </tr>
        </table>

        <toggle-detail v-if="!main && product.tieinfo"
            :initialState="!orderMeta.showDetails">
            <div class="idetail" v-html="product.tieinfo"></div>
        </toggle-detail>

        <div class="opts">
            <table class="optTable">
                <tbody v-for="option in visibleOptions"
                    :key="option.optid" class="opt">
                    <tr v-if="showOptionHeader(option)" class="head"
                        :class="[levelClass(option)]">
                        <td class="head-name" colspan="3">
                            <img v-if="option.level > 1"
                                class="indent2"
                                src="/layouts/main/styles/images/nested.png" />
                            {{parentConfigId(option)}} {{option.name}}
                            <toggle-detail v-if="option.has_details"
                                @toggled-state="toggleExpandedGroup(option.groupid)"
                                :initialState="!expanded(option.groupid)">
                            </toggle-detail>
                        </td>
                    </tr>
                    <tr class="opt" :class="[levelClass(option)]">
                        <component :is="componentType(option)"
                            @config-updated="configUpdated"
                            @input-error="forceExpanded(option.groupid)"
                            :option="option"
                            :expandedGroups="expandedGroups"
                            :hideDetails="!expanded(option.groupid)"
                            :retired="product.RETIRED">
                        </component>
                        <td class="price"
                            v-if="orderMeta.canSeePrices && orderMeta.p2.length">
                            <div v-html="displayOptionPrice(option,'price2')">
                            </div>
                        </td>
                        <td class="price text-primary"
                            v-if="orderMeta.canSeePrices && orderMeta.p1.length">
                            <div v-html="displayOptionPrice(option,'price1')">
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!--- Display a message to tell the customer to call for ordering if they don't see the option they want, these product options have been filtered. -->
        <div v-if="isFilteredProduct">
            <div class="product-downloads panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title">
                        Need something not listed?
                        <small class="text-muted">({{ product.PROD_ITEMNO }})</small>
                    </h3>
                </div>

                <div class="panel-body">
                    <div class="text-center">
                        <h4 class="bigfont marginbottom20">All Configurations</h4>
                        <p class="smaller">
                            Don't see what you need from among these options?
                        </p>
                        <p class="smaller">
                            Download the complete configuration list below:
                        </p>
                        <a
                            v-if="productConfigurationsUrl"
                            class="btn btn-default btn-sm"
                            :href="productConfigurationsUrl"
                            target="_blank"
                            rel="noopener"
                        >
                            View all product configurations
                        </a>
                    </div>

                    <!-- Price lists -->
                    <div v-if="orderMeta.canSeePrices && hasUSPriceList" class="row">
                        <div class="col-sm-12 text-center margintop20">
                            <hr />
                            <h4 class="bigfont marginbottom20">Price Lists</h4>
                            <div>
                                <ul class="list-unstyled product-downloads__links">
                                    <li v-if="hasUSPriceList">
                                        <a :href="usListUrl" target="_blank" rel="noopener" class="smaller">US List</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import useProductInfo from '../composables/useProductInfo';
import useProductConfig from '../composables/useProductConfig';
import toggleDetail from '../components/toggleDetail';
import optionRadio from '../components/optionRadio';
import optionInput from '../components/optionInput';
import useCMS from '../../shared/composables/useCMS';
import { ref, computed, watchEffect, onMounted } from '@vue/composition-api';

export default {
    name: "productConfig",
    props: {
        product: {
            PROD_ITEMNO: String,
            CONFIG_PREFIX: String,
            options: Array,
            RETIRED: Boolean,
            PROD_URL: String,
            configuration: {
                config: String,
                plist: String
            },
            PROD_CONFIG: Boolean,
            PROD_DESC: String,
            GSA: Boolean,
            tieinfo: String
        },
        main: Boolean,
        preConfig: String //Optional c_part from cart i.e. CR1000X-NA-XT-SW-IC will preselect options
    },
    components: {
        toggleDetail,
        optionRadio,
        optionInput
    },
    setup: function (props) {
        const { labels } = useCMS();
        const expandedGroups = ref([]);
        const { orderMeta } = useProductInfo();
        const isFilteredProduct = ref(false);
        const showCellDataMessage = ref(false);
        const availablePriceLists = ref([]);

        const {
            initProductConfig,
            getConfigName,
            getPrice,
            optionInConfig,
            parentConfigId,
            selectOption,
            updatePricing,
            checkPriceListAccess
        } = useProductConfig();

        const configName = computed(() => props.product.CONFIG_PREFIX + '' + getConfigName(props.product.PROD_ITEMNO));
        const visibleOptions = computed(() => {
            return props.product.options.filter(function (option) {
                return option.parent_option == '' || optionInConfig(option.parent_option, option.product_id)
            });
        });

        const price1 = computed(() => getPrice('price1', props.product.PROD_ITEMNO));
        const price2 = computed(() => getPrice('price2', props.product.PROD_ITEMNO));
        const isGSA = computed(() => (
                (orderMeta.value.p1 && orderMeta.value.p1.toLowerCase() == 'gsa') ||
                (orderMeta.value.p2 && orderMeta.value.p2.toLowerCase() == 'gsa')
            )
            && props.product.GSA);

        const hasUSOrTransferPriceList = computed(() => {
            return availablePriceLists.value.includes('US') || availablePriceLists.value.includes('TRANSFER');
        });

        const hasUSPriceList = computed(() => {
            return availablePriceLists.value.includes('US');
        });

        const hasTransferPriceList = computed(() => {
            return availablePriceLists.value.includes('TRANSFER');
        });

        const priceListBaseUrl = 'https://s.campbellsci.com/documents/us/price-lists/';
        const productItemNo = computed(() => {
            return (props.product && props.product.PROD_ITEMNO)
                ? props.product.PROD_ITEMNO.toString().trim()
                : '';
        });

        const productConfigurationsUrl = computed(() => {
            if(!productItemNo.value){
                return '';
            }
            return priceListBaseUrl + encodeURIComponent(productItemNo.value + ' Product Configurations.xlsx');
        });

        const usListUrl = computed(() => {
            if(!productItemNo.value){
                return '';
            }
            return priceListBaseUrl + encodeURIComponent(productItemNo.value + ' US List.xlsx');
        });

        const transferListUrl = computed(() => {
            if(!productItemNo.value){
                return '';
            }
            return priceListBaseUrl + encodeURIComponent(productItemNo.value + ' Transfer List.xlsx');
        });

        const setFilteredStatus = () => {
            if (props.product.WEBFILTERED === 1 || props.product.FILTERED === 1) {
                isFilteredProduct.value = true;
            } else {
                isFilteredProduct.value = false;
            }
        }
        const setCellDataStatus = () => {
            if (props.product.WEBCELLDATA === 1) {
                showCellDataMessage.value = true;
            } else {
                showCellDataMessage.value = false;
            }
        }

        const setWebProductsFlags = () => {
            // Set filtered status from web products table
            setFilteredStatus()

            // Set celldata status from web products table
            setCellDataStatus()
        }

        const toggleExpandedGroup = (groupid,state) => {
            var index = getGroupIndex(groupid);
            var stateToSet = (index > -1) ? !expandedGroups.value[index].state : !orderMeta.value.showDetails;
            if(state !== undefined) { stateToSet = state; }
            if (index > -1) {
                expandedGroups.value[index].state = stateToSet;
            } else {
                expandedGroups.value.push({
                    groupid: groupid,
                    state: stateToSet
                });
            }
        }

        const expanded = (groupid) => {
            var index = expandedGroups.value.findIndex(function (item) {
                return item.groupid == groupid;
            });
            return (index > -1) ? expandedGroups.value[index].state : orderMeta.value.showDetails;
        }

        const forceExpanded = (groupid) => {
            var index = getGroupIndex(groupid);

            if (index == -1) {
                toggleExpandedGroup(groupid,true);
            } else {
                expandedGroups.value[index].state = true;
            }
        }

        const getGroupIndex = (groupid) => {
            return expandedGroups.value.findIndex(function (item) {
                return item.groupid == groupid;
            });
        }

        const levelClass = (option) => { //Level class to index for clarity
            var level = 'l';
            return level + option.level;
        }

        const showOptionHeader = (option) => {
            return ( option.option_sort == 1 && (option.parent_option == '' || optionInConfig(option.parent_option,option.product_id)) );
        }

        const configUpdated = (option) => {
            selectOption(option);

            if (orderMeta.value.canSeePrices) {
                updatePricing(props.product);
            }
        }

        const componentType = (option) => {
            return (option.user_input) ? 'option-input' :
                'option-radio';
        }

        const displayOptionPrice = (option, type) => {
            return (option.user_input) ? option[type] + ' /' +
                option.uom : option[type];
        }

        initProductConfig(
            props.product.PROD_ITEMNO,
            props.product.cprice1,
            props.product.cprice2,
            props.preConfig.replace(props.product.CONFIG_PREFIX,''),
            props.product.options);

        watchEffect(() => { setWebProductsFlags() })

        onMounted(() => {
            checkPriceListAccess().then(function(list){
                availablePriceLists.value = list;
            });
        });

        return {
            labels,
            expandedGroups,
            orderMeta,
            parentConfigId,
            configName,
            visibleOptions,
            price1,
            price2,
            isGSA,
            isFilteredProduct,
            showCellDataMessage,
            toggleExpandedGroup,
            expanded,
            forceExpanded,
            levelClass,
            showOptionHeader,
            configUpdated,
            componentType,
            displayOptionPrice,
            hasUSOrTransferPriceList,
            hasUSPriceList,
            hasTransferPriceList,
            productConfigurationsUrl,
            usListUrl,
            transferListUrl,
            availablePriceLists
        }
    }
}
</script>
